import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class DefaultHeadersInterceptor implements HttpInterceptor {

  private PATCH: string = 'patch';
  private headerAcceptKey: string = 'Accept';
  private headerAcceptValue: string = 'application/hal+json, application/json';
  private headerContentTypeKey: string = 'Content-Type';
  private headerContentTypeValueJson: string = 'application/json';
  private headerContentTypeValueJsonPatch: string = 'application/json-patch+json';

  constructor() {
  }

  intercept(httpRequest: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let newHttpRequest: HttpRequest<any> = httpRequest.clone();
    if (!newHttpRequest.headers.has(this.headerAcceptKey)) {
      newHttpRequest = newHttpRequest.clone({ headers: newHttpRequest.headers.set(this.headerAcceptKey, this.headerAcceptValue) });
    }
    // Only add Content-Type for requests that have a body (POST, PUT, PATCH)
    // GET and DELETE requests should not have Content-Type as they have no body
    if (!newHttpRequest.headers.has(this.headerContentTypeKey) && newHttpRequest.body !== null) {
      if (newHttpRequest.method.toLowerCase() === this.PATCH.toLowerCase()) {
        newHttpRequest = newHttpRequest.clone({ headers: newHttpRequest.headers.set(this.headerContentTypeKey, this.headerContentTypeValueJsonPatch) });
      } else {
        newHttpRequest = newHttpRequest.clone({ headers: newHttpRequest.headers.set(this.headerContentTypeKey, this.headerContentTypeValueJson) });
      }
    }
    return next.handle(newHttpRequest);
  }
}
